<template>
  <div class="info-block" :class="{'is-toggled': isOpen, 'hideShadow': hideShadow, 'info-block__imaginary-header': expandedContent && imaginaryHeader}">
    <div
      :class="['info-block__header', {isClickable: collapseOnHeaderClick && toggable, vissibleBorder: vissibleHeaderBorder, vissibleToggleIcon: toggable}]"
      v-show="($slots.title || $slots.headerContent || title) && !expandedContent"
      @click="toggle"
      ref="header"
    >
      <i v-if="markerColor" class="info-block__marker" :style="{ background: markerColor }"></i>
      <div :class="['info-block__header-wrapper', {hasContent: title && $slots.headerContent}]">
        <div class="info-block__title" v-if="$slots.title || title">
          <img class="info-block__title-icon" v-if="titleIcon" :src="titleIcon" alt="Icon">
          <span v-if="$slots.title">
            <slot name="title"></slot>
          </span>
          <span v-else>{{ title }}</span>
        </div>
        <div class="info-block__header-content" v-if="$slots.headerContent">
          <slot name="headerContent"></slot>
        </div>
      </div>
      <div :class="['info-block__expand-icon', {isOpen}]" v-if="toggable" @click.stop="toggle">
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L4 6.71795L8 0H0Z" fill="#C0C4CC"></path>
        </svg>
      </div>
    </div>

    <div class="info-block__imaginary-header" v-if="expandedContent && imaginaryHeader"></div>

    <div class="info-block__content-container" v-resize="onResize" :style="{minHeight: expandedContent ? '60px' : 0}" @click="onContentContainerClick">
      <div :class="['info-block__content', {hideVerticalPadding: hideContentVerticalPadding}, {hidePaddingTop: hidePaddingTop}, {hidePaddings: expandedContent}]">
        <slot></slot>
      </div>
      <div v-if="$slots.footer || footerText" class="info-block__footer">
        <div v-if="footerText" class="info-block__footer-text">{{ footerText }}</div>
        <slot name="footer" v-else></slot>
      </div>
    </div>

    <!-- Expand icon for expanded state and when header should be hidden (expandedContent set to true) -->
    <div :class="['info-block__expand-icon', 'top-bla', {isOpen}]" v-if="toggable && expandedContent" @click="toggle">
      <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L4 6.71795L8 0H0Z" fill="#C0C4CC"></path>
      </svg>
    </div>

  </div>
</template>
<script>
  const headerHeight = 60;

  export default {
    name: 'info-block',
    props: {
      title: {
        type: String,
        default: null
      },

      // When block is open, hide title so that content takes all available space
      expandedContent: Boolean,

      // When expandedContent is true emulate clicks on the top of the page (imaginary header) will toggle the container
      imaginaryHeader: Boolean,

      markerColor: {
        type: String,
        default: null
      },
      expanded: {
        type: Boolean,
        default: true
      },
      collapseOnHeaderClick: {
        type: Boolean,
        default: true
      },
      toggable: {
        type: Boolean,
        default: true
      },
      hideShadow: Boolean,
      vissibleHeaderBorder: Boolean,
      titleIcon: String,
      footerText: String,
      hideContentVerticalPadding: {
        type: Boolean,
        default: false
      },
      hidePaddingTop: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isOpen: true
      }
    },
    methods: {
      onResize (e) {
        this.$emit('resize', e)
      },
      toggle (e) {
        if (!this.toggable) {
          return;
        }

        let target = e.target;
        let clickedOnIcon = target.closest('.info-block__expand-icon')
        if (!clickedOnIcon && !this.collapseOnHeaderClick) {
          return;
        }
        let parent = target.closest('.info-block');
        let panel = parent.querySelector('.info-block__header')

        this.isOpen = !this.isOpen
      },
      checkExpanded () {
        let title = this.$el.firstElementChild;
        let titleHeight = title.offsetHeight;
        if (this.expanded === false) {
          this.isOpen = false;
          this.$el.style.height = titleHeight + 'px';
        }
      },
      onContentContainerClick (event) {
        if (this.expandedContent && this.imaginaryHeader) {
          this.toggleOnImaginaryHeaderClick(event);
        }
      },
      toggleOnImaginaryHeaderClick (event) {
        const containerEl = this.$el.querySelector('.info-block__content-container');
        const containerRect = containerEl.getBoundingClientRect();

        if (clickedInsideImaginaryHeader()) {
          this.toggle(event);
        }

        function clickedInsideImaginaryHeader () {
          if (
            event.clientY >= containerRect.top &&
            event.clientY <= containerRect.top + headerHeight &&
            event.clientX >= containerRect.x &&
            event.clientX <= containerRect.x + containerRect.width
          ) {
            return true;
          }
          return false;
        }
      }
    },
    mounted () {
      this.checkExpanded();
    }
  }
</script>

<style lang="scss">
  @import 'src/assets/sass/core';

  .info-block {
    position: relative;
    margin-bottom: 20px;
    border-radius: $global-radius;
    background: #fff;
    box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);
    /* overflow: hidden; */

    &.hideShadow {
      box-shadow: none;
    }

    html.print & {
      display: none;
    }
    &:not(.is-toggled) {
      overflow: hidden;
    }
    &.is-toggled {
      html.print & {
        display: block;
        box-shadow: none;
      }
    }

    &__header {
      position: relative;
      display: flex;
      min-height: 60px;
      align-items: center;
      padding: 15px 30px;

      @include respond-to(phone) {
        padding: 15px 20px;
      }

      &.isClickable {
        cursor: pointer;
      }

      &.vissibleBorder {
        border-bottom: 1px solid #e4e7ed;
      }

      &.vissibleToggleIcon {
        padding-right: 60px;
      }
    }

    &__header-wrapper {
      display: grid;
      grid-template-columns: 1fr;
      width: 100%;

      &.hasContent {
        grid-template-columns: auto 1fr;
        grid-column-gap: 15px;

        @include respond-to(phone) {
          grid-template-columns: 1fr;
          grid-row-gap: 15px;
        }
      }
    }

    &__header-content {
      overflow: hidden;
      word-break: break-word;
    }

    &__marker {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 3px;
      height: 50px;
      border-bottom-right-radius: 3px;
    }

    &__expand-icon {
      position: absolute !important;
      right: 25px;
      top: 16px;
      padding: 4px;
      cursor: pointer;
      transform: rotate(-90deg);
      transition: transform 0.3s ease;

      &.isOpen {
        transform: rotate(0deg);
      }
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      color: #333333;
    }

    &__title-icon {
      margin-right: 10px;
    }

    &__content-container {
      transition: max-height 0.4s cubic-bezier(0, 1, 0, 1);
      overflow: hidden;
      max-height: 0;

      .info-block.is-toggled & {
        max-height: 99999px;
        transition: max-height 1s ease-in-out;
      }
    }

    &__content {
      padding: 15px 30px;
      opacity: 1;
      /* overflow: auto; */

      @include respond-to(phone) {
        padding: 15px 20px;
      }

      &.hideVerticalPadding {
        padding: 0 30px;

        @include respond-to(phone) {
          padding: 0 20px;
        }
      }

      &.hidePaddingTop {
        padding-top: 0 !important;
      }

      &.hidePaddings {
        padding: 0;
      }

      @media print {
        padding-left: 0;
        padding-right: 0;
      }
    }

    &__footer {
      padding: 0 30px 15px 30px;
      @include respond-to(phone) {
        padding: 0 15px 15px 15px;
      }
    }

    &__footer-text {
      font-size: 10px;
      color: #bbbdbf;
      text-align: right;
    }

    .info-block__content .workplaces-container {
      box-shadow: none;
      margin-bottom: 0;

      .profile-block:first-child,
      .profile-block:nth-child(2n + 1) {
        border-left: none;
      }
    }

    &__imaginary-header .profile-block__title {
      cursor: pointer;
    }
  }
</style>